/* global */

import Layzr from 'layzr.js'

export default class LazyLoader {
  constructor() {
    this.initLazyLoading({ threshold: 50 })
  }

  initLazyLoading(options = {}) {
    this.instance = Layzr(options)
    this.instance.update().check().handlers(true)
  }
}
